import {TextArea} from "@blueprintjs/core";
import styled from "@emotion/styled";

export const FillTextArea = styled(TextArea)`
    width: 100%;
`;
